//initial redux
import { put, call, takeEvery, fork, all, takeLatest, select } from "redux-saga/effects";
import { Interval, Point, PointDisplay } from "../../../services/Live/types";
import reportservice from "../../../services/reports";
import { TreeFlatener, TreeMap, DateTime, AsyncSaga, string, persist } from "../../../utils";
import moment from "moment";
import ruleservice from "../../../services/rules";
import { types as rulestypes } from "../Rules/redux";
import config from "../../../boot/config";

const initialState = {
	report: {
		components: [],
		ruleInstance: {}
	},

	calendarOpen: false,
	isBusy: false,
	errors: [],
	hasError: false,
	totalComponents: 0,
	componentsLoadedCount: 0,
	componentsLoaded: false,
	loadedIndices: [],
	pdfDownloadInProgress: false,
};

const persistConf = {
	whitelist: [""]
};

/////////
//types
export const types = {
	GET_REPORT: "screens/rules/reports/GET_REPORT",
	ON_GET_REPORT: "screens/rules/reports/ON_GET_REPORT",
	SELECT_PERIOD: "screens/rules/reports/SELECT_PERIOD",
	TOGGLE_CALENDAR: "screens/rules/reports/TOGGLE_CALENDAR",
	ON_COMPONENT_LOADED: "screens/rules/reports/ON_COMPONENT_LOADED",
	DOWNLOAD_PDF: "screens/rules/reports/DOWNLOAD_PDF",
    PDF_DOWNLOAD_COMPLETE: "screens/rules/reports/PDF_DOWNLOAD_COMPLETE",
    RESET_STATE: "screens/rules/reports/RESET_STATE"
};

///////////
//reducers
const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.GET_REPORT: {
				return state;
			}
			case types.ON_COMPONENT_LOADED: {
				let loadedIndex = action.payload.index;
				let alreadyLoaded = state.loadedIndices.indexOf(loadedIndex) != -1;
				if(!alreadyLoaded){
					let newComponentsLoadedCount = state.componentsLoadedCount + 1;
					return {...state, componentsLoadedCount: newComponentsLoadedCount, 
						componentsLoaded: newComponentsLoadedCount === state.totalComponents,
						loadedIndices: [...state.loadedIndices, action.payload.index]
						}
				}else{
					return state;
				}
			}
			case types.ON_GET_REPORT: {
				let totalComponents = 0;
				if(action.payload.report && action.payload.report.components && action.payload.report.components.length){
					totalComponents = action.payload.report.components.length;
				}
				return { ...state, report: action.payload.report, totalComponents: totalComponents };
			}
			case types.SELECT_PERIOD: {
				return { ...state, timePeriod: action.payload.period };
			}
			case types.TOGGLE_CALENDAR: {
				return { ...state, calendarOpen: !state.calendarOpen };
			}

			case types.DOWNLOAD_PDF: {
				return {...state, pdfDownloadInProgress: true};
			}
			case types.PDF_DOWNLOAD_COMPLETE: {
				return {...state, pdfDownloadInProgress: false};
            }
            case types.RESET_STATE:
                return initialState;
			default:
				return state;
		}
	}
};
export const reducer = persist("rulesreports", reducers.reducer, persistConf);

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([
			this.getReport(),
			this.downloadPdf(),
		]);
	},
	*downloadPdf(){
		yield takeEvery(types.DOWNLOAD_PDF, function*({payload}){
			var ruleInstanceId = payload.ruleInstanceId;
			var time = yield select(x => x.time.timeRange);
			var startDate = moment(time.startDate);
			var endDate = moment(time.endDate);
			var pdfName = yield call(reportservice.GeneratePdf, ruleInstanceId, startDate, endDate);
			if(!(pdfName instanceof Error)){
				var pdfUrl = window.REDI_enviromentConfig.siteBaseUrl + "Temp/" + pdfName;
				var a = document.createElement('a');
				a.href = pdfUrl;
				a.target = '_blank';
				a.click();
			}else{
				let errorMessage = "Pdf Generation failed! \n";
				if(pdfName.exceptionMessage){
					errorMessage += pdfName.exceptionMessage;
				}
				alert(errorMessage);
			}
			yield put(actions.pdfDownloadComplete());
		});
	},
	*getReport() {
		yield takeLatest(types.GET_REPORT, function*({ payload }) {
			const [data, ri] = yield all([
				call(reportservice.GetReport, payload.ruleInstanceId),
				call(ruleservice.GetRuleInstance, payload.ruleInstanceId)
			]);

			if (data instanceof Error || ri instanceof Error || data.components === null) {
				yield put(
					actions.onGetReport({
						components: [],
						ruleInstance: {},
						null_report: true
					})
				);
			} else {
				if (data && data.components && data.components.length) {
					ri.config = JSON.parse(ri.configJson, string.toCamelCase);
					data.ruleInstance = ri;
					yield put(actions.onGetReport(data));
				}
			}
		});
	}
};
////////
//actions
export const actions = {
	getReport(ruleInstanceId) {
		return {
			type: types.GET_REPORT,
			payload: { ruleInstanceId }
		};
	},
	onGetReport(report) {
		return {
			type: types.ON_GET_REPORT,
			payload: { report }
		};
	},
	selectPeriod(period) {
		return {
			type: types.SELECT_PERIOD,
			payload: { period }
		};
	},
	toggleCalendar() {
		return {
			type: types.TOGGLE_CALENDAR,
			payload: {}
		};
	},
	changeTime(time) {
		return {
			type: types.CHANGE_TIME,
			payload: { time: time.selection }
		};
	},
	onChangeTime(map, time) {
		return {
			type: types.ON_CHANGE_TIME,
			payload: { map, time }
		};
	},
	onComponentLoaded(index){
		return {
			type: types.ON_COMPONENT_LOADED,
			payload: {index}
		};
	},
	downloadPdf(ruleInstanceId){
		return {
			type: types.DOWNLOAD_PDF,
			payload: {ruleInstanceId}
		};
	},
	pdfDownloadComplete(){
		return {
			type: types.PDF_DOWNLOAD_COMPLETE,
			payload: {}
		};
    },
    resetState() {
        return {
            type: types.RESET_STATE
        }
	 },
	 getCommentList(ruleInstanceId, from, to) {
		 return {
			 type: "components/chartcomment/GET_COMMENT_LIST",
			 payload: { ruleInstanceId, from, to }
		 }
	 }
};



// WEBPACK FOOTER //
// ./src/ui/Rules/Reports/redux.js